export function removeNullKeys(obj) {
    if(typeof obj !== 'object' || obj === null) return obj;

    let newObj = {}

    for(let i in obj) {
        if(obj[i] !== null){
            newObj[i] = obj[i];
        }
    }

    return newObj;
}

export const DEFAULT_ROUTE_COLOR = '#009FE3';
export const DEFAULT_ROUTE_TEXT_COLOR = '#FFFFFF';

export function routeColor(color) {
    return color ? '#' + color : DEFAULT_ROUTE_COLOR;
}

export function routeTextColor(color) {
    return color ? '#' + color : DEFAULT_ROUTE_TEXT_COLOR;
}